// extracted by mini-css-extract-plugin
export default {"header":"Menu_header__zp3Tq","menu--mobile":"Menu_menu--mobile__fRpNH","menu--regular":"Menu_menu--regular__0DdOq"};